<template>
  <svg
    class="custom-icon"
    width="18"
    height="13"
    viewBox="0 0 18 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.64859 6.67898C1.14226 6.80675 -0.0235834 8.13788 0.000362319 9.74999V9.92939C0.000362319 11.6182 1.31203 13 2.91528 13H14.2345C16.2998 13 18 11.2344 18 9.03356V8.9058C18 6.80689 16.4454 5.09271 14.5021 4.93898C13.9192 2.04716 11.49 0 8.67242 0H8.62383C5.34465 0 2.64859 2.81481 2.64859 6.29524V6.67898ZM8.68692 4.82308C9.93148 4.82308 10.9448 5.78147 10.964 6.96617L9.16667 6.96622L11.9468 10.5866L14.5 6.9788L12.873 6.96619C12.8539 4.7762 10.9838 3 8.68692 3C6.37819 3 4.5 4.79447 4.5 6.9999C4.5 9.20555 6.37817 11 8.68692 11V9.17708C7.43038 9.17708 6.40813 8.20036 6.40813 6.99988C6.40813 5.79966 7.43032 4.82308 8.68692 4.82308Z"
    />
  </svg>
</template>
